import React, { FC, useEffect } from "react";
import { logEvent } from "../../../../helpers/analytics";
import Button from "@laborhack/custom-button";
import { Icon } from "semantic-ui-react";

export interface ArtisanSignInProps {}

export const ArtisanSignIn: FC<ArtisanSignInProps> = ({}) => {
  useEffect(() => {
    logEvent("viewed_artisan_sign_in_form");
  }, []);
  return (
    <div>
      <h3 className="text-primary-500 font-bold">Artisan Sign In</h3>
      <a href={process.env.REACT_APP_PRO_APPLICATION_URL}>
        <Button type="link">
          Continue at pro.laborhack.com <Icon name="external alternate" />
        </Button>
      </a>
    </div>
  );
};
